function compareStrings(str1, str2) {
    // Convert both strings to lowercase and remove accents
    const normalizedStr1 = str1.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const normalizedStr2 = str2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Use localeCompare for case-insensitive comparison
    if (normalizedStr1.includes(normalizedStr2)) {
        return true;
    }
    return false;
}

export function search() {
    let resultsArray = []
    if (document.getElementById('search-box') && document.getElementById('search-box').value) {
        const input = document.getElementById('search-box').value;
        resultsArray.map((each) => {
            each.className.includes('share-match') ? each.style.backgroundColor = '#66ffad' : each.style.backgroundColor = 'transparent';
        });
        resultsArray = [];
        if (input != '') {
            const section = Array.from(document.getElementsByTagName('section')[0].childNodes);
            section.map((paragraph) => {
                Array.from(paragraph.childNodes).map((word) => {
                    if (word.childNodes[0] && compareStrings(word.childNodes[0].data, input)) {
                        resultsArray.push(word);
                        word.style.backgroundColor = 'rgba(255, 255, 0, 0.4)';
                    }
                });
            });
        }
    }
    return resultsArray
}

export function clearSearch() {
    document.getElementById('search-box').value = '';
    const section = Array.from(document.getElementsByTagName('section')[0].childNodes);
    section.map((paragraph) => {
        Array.from(paragraph.childNodes).map((word) => {
            if (word.style.backgroundColor == 'rgba(255, 255, 0, 0.4)') {
                word.style.backgroundColor = 'transparent'
            }
        });
    })
}

export default search;